// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"160":"b850e7c4","688":"559ebdee"}[chunkId] + ".chunk.css";
};